<template>
  <section class="index">
    <div class="container">
      <div class="gc-page-container">
        <div class="container-center">
          <div class="shuomin"></div>
          <section class="gc-page-tmp">
            <div class="top-bg"></div>
            <a
              href="javascript:void(0)"
              class="bg-btn zhuan"
              @click="entryQuestion"
              >进入问卷</a
            >
            <p class="top-notice">当前奖励金标准为3元</p>
          </section>

          <section class="gc-page">
            <div class="sub-content">
              <p>1. 回答成功获奖励金3元</p>
              <p>2. 回答失败获10个点子（限当日前5次）</p>
              <p>3. 奖励金实时兑付</p>
              <p>
                4. 尝鲜期每日限量1000份
              </p>
            </div>
          </section>

          <section class="gc-page" v-for="(item, index) in list" :key="item.id">
            <!-- 已完成 -->
            <div class="gc-headImg-ctx">
              <img class="gc-headImg" src="../assets/img/cash.png" />
            </div>
            <div class="gc-page-top done">
              <div class="gc-money">3<span>元</span></div>
              <div class="done-status" v-if="item.status == 2">已申请</div>
              <div class="done-status" v-else-if="item.status == 1">已提现</div>
              <div class="done-status" v-else>已失败</div>
            </div>
            <div class="gc-page-center">
              <p class="gc-nickname">{{ item.sur }}</p>
              <p class="gc-title">肥牛卷</p>
              <!-- <p class="gc-subtitle">关于你的问卷调查</p> 创建时间： -->
            </div>
            <div class="gc-qrtime">{{ item.addtime }}</div>
            <div class="gc-qrcode">
              <div class="gc-qrcode-text" @click="showDetail(item)">详情</div>
            </div>
          </section>

          <section class="gc-page" v-if="pageNum < pages">
            <div class="load-more">
              <button class="load-btn" @click="loadMore">加载更多</button>
            </div>
          </section>
        </div>
      </div>
    </div>

    <div class="bg-base" v-if="isShow">
      <!-- 现金问卷 -->
      <div class="bg-card">
        <div class="bg-close">
          <img
            src="../assets/img/close-area.png"
            alt=""
            @click.stop="closeDialog"
          />
        </div>
        <div class="bg-top">
          <div class="bg-top-left">
            <img src="../assets/img/cash.png" alt="" />
            <span>奖励金转入微信零钱</span>
          </div>
          <template v-if="dialog.status == 2">
            <div class="status greenColor">已申请</div>
          </template>
          <template v-else-if="dialog.status == 1">
            <div class="status redColor">已提现</div>
          </template>
          <template v-else>
            <div class="status grayColor">已失败</div>
          </template>
        </div>
        <div class="bg-cell">
          <div class="bg-cell-title">成交金额</div>
          <div class="bg-cell-money">{{ dialog.money }}元</div>
        </div>
        <div class="bg-cell-cl">
          <div class="bg-cell-title">交易详情</div>
          <div class="bg-cell-text">[{{ dialog.ssiprid }}]肥牛卷</div>
        </div>
        <div class="bg-cell-cl">
          <div class="bg-cell-title">账户详情</div>
          <div class="bg-cell-text" v-if="dialog.status == 2">
            备注：已申请奖励金转入微信零钱
          </div>
          <div class="bg-cell-text" v-if="dialog.status == 1">
            备注：已申请奖励金转入微信零钱
          </div>
          <div class="bg-cell-text" v-else>
            备注：当日提现名额超限，请隔日申请
          </div>
          <div class="bg-cell-text">创建时间：{{ dialog.addtime }}</div>
        </div>
        <div class="bg-cell-cl" v-if="dialog.status == 1">
          <div class="bg-cell-title">成功提现</div>
          <div class="bg-cell-text">奖励金已转入微信零钱</div>
          <div class="bg-cell-text">交易号：{{ dialog.orderno }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getCookie } from "../utils";

export default {
  data() {
    return {
      pageNum: 1,
      pages: 0,
      list: [],

      isShow: false,
      dialog: null
    };
  },
  mounted() {
    this.getDoneList();
  },
  methods: {
    entryQuestion() {
      let unionId = getCookie("unionId");
      this.$axios
        .get(
          `https://home.51point.com/51point-0.0.1-SNAPSHOT/c/cc?u=${unionId}&source=1`
        )
        .then(res => {
          if (res.data.code == 1 && res.data.data) {
            window.location.href = res.data.data;
          } else if (res.data.code == 0 && res.data.data) {
            this.$message.error(res.data.data);
          } else {
            this.$message.error(`暂未请求到问卷`);
          }
        });
    },

    getDoneList() {
      let unionId = getCookie("unionId");
      this.axios
        .get(
          `https://home.51point.com/51point-0.0.1-SNAPSHOT/c/getCComplete?unionId=${unionId}&pageSize=50&pageNum=${
            this.pageNum
          }&type=1`
        )
        .then(res => {
          if (res.data.code == 1) {
            if (this.pageNum > 1) {
              this.list = this.list.concat(res.data.data);
            } else {
              this.list = res.data.data;
            }
            this.pages = res.data.pages;
          }
        });
    },

    loadMore() {
      if (this.pageNum < this.pages) {
        this.pageNum += 1;
        this.getDoneList();
      }
    },

    showDetail(e) {
      this.axios
        .get(
          `https://home.51point.com/51point-0.0.1-SNAPSHOT/c/getCiDetail?hash=${
            e.hash
          }`
        )
        .then(res => {
          this.dialog = res.data.data;
          this.isShow = true;
        });
    },

    closeDialog() {
      this.isShow = false;
    }
  }
};
</script>

<style scoped>
.load-more {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.load-btn {
  font-size: 14px;
  color: #666;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  padding: 20px 24px;
  cursor: pointer;
  background-color: white;
}

.bulbs-content {
  margin: 0.5rem 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.index .gc-qrcode-img {
  width: 125px;
  height: 125px;
  margin: 20px auto;
}
.index .wxssk {
  font-size: 12px;
  color: #666666;
  text-align: center;
}
.index .gc-qrcode-ctx {
  width: 160px;
  height: 200px;
  background: #ffffff;
  border: 1px solid #efefef;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.08);
  border-radius: 2px;
}
.index .gc-qrcode {
  position: absolute;
  bottom: 20px;
  right: 15px;
}
.index .gc-qrcode-text {
  font-size: 13px;
  color: #959499;
  border: 1px solid #d8d8d8;
  border-radius: 2px;
  /* width: 60px; */
  padding-left: 10px;
  padding-right: 10px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  float: right;
  margin-top: 10px;
  cursor: pointer;
}
.index .gc-qrcode-text:hover {
  background: #c9c9ce;
  border-color: #c9c9ce;
  color: #fff;
}
.index .gc-page {
  float: left;
  /* margin-right: 20px; */
  margin-left: 10px;
  margin-right: 10px;
}
.index .gc-category {
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 2;
  border-radius: 100px;
  background-color: rgba(0, 0, 0, 0.7);
  font-size: 11px;
  color: #ffffff;
  padding: 5px;
}
.index .gc-page-bottom {
  position: absolute;
  bottom: 20px;
  z-index: 2;
  left: 15px;
  height: 16px;
  line-height: 16px;
  width: 150px;
  font-size: 12px;
  color: #9b9b9b;
}
.index .gc-headImg-ctx {
  position: absolute;
  top: 125px;
  left: 15px;
  z-index: 2;
  width: 32px;
  height: 32px;
}
.index .gc-headImg {
  width: 32px;
  height: 32px;
  border-radius: 32px;
  border: 2px solid #ffffff;
}
.index .gc-page-top {
  width: 280px;
  height: 140px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  /* justify-content: center; */
  justify-content: flex-end;
}

.index .gc-page-top img {
  width: 100%;
  height: 100%;
}

.index .gc-page-center {
  position: relative;
  padding: 15px;
  padding-top: 25px;
}
.index .gc-nickname {
  font-size: 13px;
  color: #666666;
  margin-bottom: 15px;
}
.index .gc-title {
  font-size: 15px;
  color: #333;
  margin-bottom: 12px;
  line-height: 22px;
}
.index .gc-subtitle {
  font-size: 12px;
  color: #888888;
  line-height: 18px;
  /* max-height: 54px; */
  overflow: hidden;
}

.index .notice-subtitle {
  font-size: 12px;
  color: #65ae71;
  line-height: 18px;
  max-height: 54px;
  overflow: hidden;
}
.index .notice-subtitle .big {
  font-size: 18px;
}
.index .gc-page {
  width: 280px;
  height: 360px;
  background: #ffffff;
  /* cursor: pointer; */
  position: relative;
  margin-bottom: 20px;
}
.index .gc-page:hover {
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.08);
}

.mar-top {
  margin-top: 20px;
}

.noQ {
  display: block;
  padding-top: 20px;
}

.noQ p {
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 28px;
}

.noQ-div {
  width: 260px;
  height: 196.48px;
  margin: 0 auto;
  background-size: 360px 196.48px;
  padding-top: 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.noQ .noQ-link {
  color: #65ae71;
  border-bottom: 3px double #65ae71;
}

.index .gc-qrtime {
  position: absolute;
  bottom: 20px;
  left: 15px;
  font-size: 10px;
  color: #999;
}

.done {
  background: #9fc2e2;
}

.ing {
  background: #d4b7b5;
}

.done-status {
  /* position: relative;
  left: 105px;
  top: 8px; */
  /* width: 280px;
  height: 360px; */
  color: white;
  display: flex;
  flex-direction: row-reverse;
  margin-right: 5px;
  margin-bottom: 5px;
}

.ing-status {
  position: relative;
  left: 115px;
  top: 110px;
  color: white;
}

.ing-status span {
  font-size: 160%;
  margin-right: 4px;
}

.noQ-title {
  font-size: 14px;
  color: #999;
  margin-top: 20px;
}

.noQ-button {
  width: 100px;
  height: 35px;
  background: #5dac5b;
  color: white;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  margin: 10px auto;
  cursor: pointer;
}

.noQ-con {
  text-align: center;
}

.gc-money {
  color: white;
  font-size: 80px;
  text-align: center;
  margin-bottom: -10px;
  /* font-weight: 545; */
}

.gc-money span {
  font-size: 20px;
  margin-left: 5px;
  /* font-weight: normal; */
}

.index .gc-page-tmp {
  float: left;
  /* margin-right: 20px; */
  margin-left: 10px;
  margin-right: 10px;
  width: 280px;
  height: 360px;
  background: #ffffff;
  position: relative;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.index .gc-page-tmp:hover {
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.08);
}

.top-bg {
  height: 50%;
  width: 100%;
  background: #c9cfbc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.bg-btn {
  width: 90%;
  height: 45px;
  color: white;
  display: block;
  border-radius: 4px;
  font-size: 15px;
  line-height: 45px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.zhuan {
  background: #65ae71;
}

.exit {
  background: #f16754;
}

.top-point {
  font-size: 48px;
  color: white;
  margin-bottom: 30px;
}

.top-point span {
  font-size: 15px;
  margin-left: 5px;
}

.top-title {
  font-size: 14px;
  color: #fff;
  margin-left: 10px;
}

.top-title span {
  opacity: 0.5;
  font-size: 12px;
  margin-left: 10px;
  color: #fff;
}

.top-bottom {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
}

.top-bottom img {
  height: 18px;
  width: 18px;
  margin-right: 10px;
}

.top-notice {
  font-size: 14px;
  color: #999;
  text-align: center;
  margin-top: 10px;
}

.sub-content {
  margin: 20px 20px;
  padding: 20px 20px;
}

.sub-content p {
  font-size: 12px;
  color: #666;
  line-height: 20px;
  letter-spacing: 0;
}

.index .container {
  min-height: 540px;
}

/*  */
.shuomin {
  color: #999;
  font-size: 14px;
  margin: 20px 0px;
  padding-left: 10px;
  width: calc(100% - 10px);
}

.gc-page-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0 auto;
}

.index .container-center {
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
}

/* 手机 */
@media screen and (max-width: 768px) {
  .index .container-center {
    width: 300px;
  }
}

/* Pad */
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .index .container-center {
    width: 600px;
  }
}

/* 中屏幕电脑 */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .index .container-center {
    width: 900px;
  }
}

/* 大屏幕电脑 */
@media screen and (min-width: 1200px) {
  .index .container-center {
    width: 1200px;
  }
}

.bg-base {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-close {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  height: 20px;
  margin-top: 10px;
}

.bg-close img {
  width: 14px;
  height: 14px;
  margin-right: 20px;
}

.bg-card {
  background: #ebebeb;
  border-radius: 4px;
  /* width: 400px; */
  height: 600px;
  -webkit-box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  -webkit-animation: fadeInDown 0.3s;
  animation: fadeInDown 0.3s;
}

@keyframes fadeInDown {
  0% {
    -webkit-transform: translate3d(0, -20%, 0);
    -webkit-transform: translate3d(0, -20%, 0);
    transform: translate3d(0, -20%, 0);
    transform: translate3d(0, -20%, 0);
    opacity: 0;
  }
  100% {
    -webkit-transform: none;
    transform: none;
    opacity: 1;
  }
}

.bg-top {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}

.bg-top-left {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bg-top-left img {
  width: 30px;
  height: 30px;
}

.bg-top-left span {
  font-size: 14px;
  color: #333;
  margin-left: 10px;
}

.status {
  color: #65ae71;
  font-size: 14px;
}

.bg-cell {
  background: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 10px;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
}

.bg-cell-cl {
  background: white;
  display: flex;
  flex-direction: column;
  padding: 10px 10px;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
}

.bg-cell-title {
  font-size: 13px;
  color: #999;
}

.bg-cell-text {
  font-size: 14px;
  color: #333;
  margin-top: 10px;
}

.bg-cell-money {
  font-size: 20px;
  color: #333;
}

.greenColor {
  color: #65ae71;
}

.redColor {
  color: #f08177;
}

.grayColor {
  color: #999;
}

.finish-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.finish-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 20px;
  margin-left: 10px;
  margin-right: 10px;
  background: #65ae71;
  border-radius: 4px;
  color: #fff;
  font-size: 15px;
  text-align: center;
  line-height: 45px;
  width: 380px;
}

.finish-err-btn {
  border-radius: 4px;
  color: #fff;
  font-size: 15px;
  text-align: center;
  line-height: 45px;
  background: #a6a6a6;
  margin-left: 10px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 20px;
}

.zh-container {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
}

.zh-notice-content {
  flex-shrink: 0;
}

.zh-notice {
  font-size: 14px;
  color: #666;
  line-height: 20px;
}

.zh-space-left {
  flex-grow: 1;
}

.zh-space-right {
  flex-grow: 3;
}
.errcolor {
  background: #a6a6a6;
}

/* 手机 */
@media screen and (max-width: 768px) {
  .bg-card {
    width: 90%;
    position: relative;
  }
}

/* Pad */
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .bg-card {
    width: 400px;
    position: relative;
  }
}

/* 中屏幕电脑 */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .bg-card {
    width: 400px;
    position: relative;
  }
}

/* 大屏幕电脑 */
@media screen and (min-width: 1200px) {
  .bg-card {
    width: 400px;
    position: relative;
  }
}

.qr_code {
  position: absolute;
  bottom: 10px;
  left: 90px;
  width: 220px;
  height: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.3);
  -webkit-animation: fadeInDown 0.3s;
  animation: fadeInDown 0.3s;
}

.qr_code img {
  width: 200px;
  height: 200px;
}
</style>
